import { Avatar, Box, Flex, Text } from '@chakra-ui/react'
import { COLORS } from '@ds/tokens/legacy/colors'
import { useNavigate } from 'react-router-dom'
import { getFullName } from 'shared-utils'

import { useMember } from '@/app/user/api/members/selector'
import { TEXT_ENUM } from '@/styles/components/text'

const AVATAR_CONTAINER_WIDTH = '36px'
const PROFILE_PATH = '/settings/user/profile'

type Props = {
	isHovered: boolean
	isFullyExpanded: boolean
	onMouseEnter?: () => void
}

export const SidebarProfile = ({
	isHovered,
	isFullyExpanded,
	onMouseEnter,
}: Props) => {
	const member = useMember()?.member
	const navigate = useNavigate()

	const fullName = getFullName({
		firstName: member?.first_name,
		lastName: member?.last_name,
	})

	const handleClick = (e: React.MouseEvent) => {
		if (e.button === 0 && !e.ctrlKey && !e.metaKey) {
			e.preventDefault()
			navigate(PROFILE_PATH)
		}
	}

	return (
		<Box
			as="a"
			href={PROFILE_PATH}
			onClick={handleClick}
			_hover={{
				textDecoration: 'none',
			}}
			userSelect="none"
		>
			<Flex
				position="relative"
				w={isHovered ? 'full' : AVATAR_CONTAINER_WIDTH}
				h="36px"
				onMouseEnter={onMouseEnter}
				transition="width 250ms ease-in-out"
			>
				<Flex
					position="absolute"
					left="0"
					top="0"
					w={AVATAR_CONTAINER_WIDTH}
					h="36px"
					alignItems="center"
					justifyContent="center"
				>
					<Avatar
						w="32px"
						h="32px"
						src={member?.avatar_url || undefined}
						name={fullName || ''}
						borderRadius="full"
					/>
				</Flex>

				{isHovered && isFullyExpanded && (
					<Flex
						h="100%"
						alignItems="center"
						ml={`calc(${AVATAR_CONTAINER_WIDTH} + 12px)`}
						opacity={1}
						transition="opacity 250ms ease-in-out"
						animation="fadeIn 250ms ease-in-out"
						userSelect="none"
						sx={{
							'@keyframes fadeIn': {
								'0%': { opacity: 0 },
								'100%': { opacity: 1 },
							},
						}}
					>
						<Flex flexDir="column">
							<Text
								variant={TEXT_ENUM.medium14}
								noOfLines={1}
								overflow="hidden"
								textOverflow="clip"
								userSelect="none"
							>
								{fullName || '-'}
							</Text>
							<Text
								variant={TEXT_ENUM.regular12}
								color={COLORS.gray[9]}
								noOfLines={1}
								overflow="hidden"
								textOverflow="clip"
								userSelect="none"
							>
								{member?.email ?? ''}
							</Text>
						</Flex>
					</Flex>
				)}
			</Flex>
		</Box>
	)
}
